import { List } from "models/list";
import { StateCreator } from "zustand";

export interface ListTemplatesSlice {
  listTemplates: List[];
}

export const createListTemplatesSlice: StateCreator<
  ListTemplatesSlice,
  [],
  [],
  ListTemplatesSlice
> = () => ({
  listTemplates: [],
});
